module.exports = __webpack_public_path__ + "chat.c05bc967.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/headers/chat.svg
// module id = 1729
// module chunks = 0